import React, { Component } from "react";
import Navbar from "../../../components/Navbar.js";
import Select from "react-select";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import {
    tokens,
    select_style,
    // alert
    alert,
    // function
    format_date,
    toFixed,
    // api
    GET,
    // storage
    getStorage,
} from "../../../components/CustomComponent.js";

import "../../../components/global.js";
import "../../../assets/css/bootstrap.css";
import "../../../assets/css/index.css";

import { utils as XLSXUtils, write as XLSXWrite } from 'xlsx';
import { saveAs } from 'file-saver';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

// Custom DatePicker component with icon
const CustomDatePicker = ({ selected, onChange, placeholderText, minDate, maxDate }) => {
    return (
        <div className="position-relative">
            <DatePicker
                className="form-control"
                selected={selected}
                onChange={onChange}
                dateFormat="dd/MM/yyyy"
                placeholderText={placeholderText}
                minDate={minDate}
                maxDate={maxDate}
                isClearable
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
            />
            <div className="position-absolute" style={{ right: "10px", top: "50%", transform: "translateY(-50%)", pointerEvents: "none" }}>
                <span className="icon text-muted">{"\uf133"}</span> {/* Calendar icon */}
            </div>
        </div>
    );
};

export default class StockReport extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            data: [],
            data_categories: [],
            data_warehouse: [],
            data_product: [],
            selected_category: null,
            selected_warehouse: null,
            selected_product: null,
            sum_total_price: 0,
            searchText: "",
            startDate: new Date(), // Set current date as default
            endDate: new Date(), // Set current date as default
            exportLoading: false,
            currentStockType: "export" // Default to "export" (เบิกสินค้า)
        }
    }

    async componentDidMount() {
        this.setState({ loading: true });
        await this.GetCategories();
        await this.GetWarehouse();
        await this.GetStockList();
        // await this.GetAllStockList();
        this.setState({ loading: false });
    }
    
    GetWarehouse = async () => {
        this.setState({ loading: true });
        let body = {
            page: 0,
            data_search: ""
        }
        try {
            let result = await GET(tokens, "v1/TH/warehouse-info/list/" + getStorage("branch").branch_id, body);
            if (result && result.status) {
                console.log("Warehouse data:", result.data);
                this.setState({ 
                    data_warehouse: result.data.map(e => { 
                        return { 
                            value: e.warehouse_id, 
                            label: e.warehouse_name 
                        } 
                    })
                });
            } else {
                console.error("Failed to fetch warehouse data");
                this.setState({ data_warehouse: [] });
            }
        } catch (error) {
            console.error("Error fetching warehouse data:", error);
            this.setState({ data_warehouse: [] });
        }
        this.setState({ loading: false });
    }
    
    GetProducts = async () => {
        this.setState({ loading: true });
        let body = {
            page: 0,
            data_search: "",
            product_id: ""
        }
        try {
            let result = await GET(tokens, "v1/TH/product-manage/product/list/" + getStorage("branch").branch_id, body);
            if (result && result.status) {
                console.log("Product data:", result.data);
                this.setState({ 
                    data_product: result.data.map(e => { 
                        return { 
                            value: e.product_id, 
                            label: e.product_name,
                            product_code: e.product_code
                        } 
                    })
                });
            } else {
                console.error("Failed to fetch product data");
                this.setState({ data_product: [] });
            }
        } catch (error) {
            console.error("Error fetching product data:", error);
            this.setState({ data_product: [] });
        }
        this.setState({ loading: false });
    }

    GetCategories = async () => {
        this.setState({ loading: true });
        
        // Categories for stock movement type
        const categories = [
            { value: "all", label: "ทั้งหมด" },
            { value: "export", label: "เบิกสินค้า" },
            { value: "import", label: "รับสินค้าเข้า" }
        ];
        
        try {
            // You could also fetch categories from API if needed
            // let body = {
            //    page: 0,
            //    data_search: ""
            // };
            // let result = await GET(tokens, "v1/TH/categories/list/" + getStorage("branch").branch_id, body);
            // if (result && result.status) {
            //    // Process API result
            //    const apiCategories = result.data.map(cat => ({ 
            //        value: cat.category_id, 
            //        label: cat.category_name 
            //    }));
            //    this.setState({ data_categories: [{ value: "all", label: "ทั้งหมด" }, ...apiCategories] });
            // } else {
                this.setState({ data_categories: categories });
            // }
        } catch (error) {
            console.error("Error fetching categories:", error);
            this.setState({ data_categories: categories });
        }
        
        this.setState({ loading: false });
    }

    GetStockList = async () => {
        this.setState({ loading: true });

        // Format dates for API request
        const startDate = this.state.startDate ? format_date(this.state.startDate, "yyyy-mm-dd", "en") : "";
        const endDate = this.state.endDate ? format_date(this.state.endDate, "yyyy-mm-dd", "en") : "";
        
        // Prepare request body
        let body = {
            page: 0,
            decision_status: 1,
            data_search: this.state.searchText,
            category_type: this.state.selected_category ? this.state.selected_category.value : "",
            start_date: startDate,
            end_date: endDate,
            deposite_type: this.state.selected_category ? this.state.selected_category.value === "export" ? "buy" : "all" : "all"
        };
        
        // Call API
        let result = await GET(tokens, "v1/TH/goods-issuance-manage/list/" + getStorage("branch").branch_id, body);
        
        if (result && result.status) {
            console.log("Stock data:", result.data);
            
            // Process the data to match our display format
            const processedData = [];
            
            // Check if data is an array (list of receipts) or single object (detailed receipt)
            const receiptsArray = Array.isArray(result.data) ? result.data : [result.data];
            let sum_total_price = 0;
            // For each receipt, get its full details
            for (const receipt of receiptsArray) {
                const detailBody = {
                    page: 0,
                    data_search: "",
                    goods_issuance_main_id: receipt.goods_issuance_main_id
                };
                
                const detailResult = await GET(
                    tokens, 
                    "v1/TH/goods-issuance-manage/list/" + getStorage("branch").branch_id, 
                    detailBody
                );
                
                if (detailResult && detailResult.status) {
                    const receiptDetail = detailResult.data;
                    
                    // Format each receipt into our display format
                    const formattedReceipt = {
                        receipt_id: receiptDetail.goods_issuance_code || "",
                        receipt_date: receiptDetail.goods_issuance_date || "",
                        receipt_type: receiptDetail.deposite_type === "buy" ? "เบิกเพื่อขาย" : "เบิกเพื่อซ่อม",
                        reference_number: receiptDetail.ref_repaire_code || "",
                        company_name: receiptDetail.relation_company ? receiptDetail.relation_company.company_name : 
                                     (receiptDetail.goods_issuance_by_user ? receiptDetail.goods_issuance_by_user.full_name : ""),
                        goods_issuance_by: receiptDetail.goods_issuance_by.name || "-",
                        items: [],
                    };
                    
                    
                    // Add items from goods_issuance_list
                    if (receiptDetail.goods_issuance_list && receiptDetail.goods_issuance_list.length > 0) {
                        for (const item of receiptDetail.goods_issuance_list) {
                            formattedReceipt.items.push({
                                product_code: item.all_stock_data?.product_main_data?.product_code || "-",
                                product_name: item.all_stock_data?.product_main_data?.product_name || "-",
                                product_type: item.all_stock_data?.warehouse_name || "-",
                                quantity: item.quantity || 0,
                                total_price: item.total_price || 0,
                                price_per_piece: item.price_per_piece || 0,
                                unit: item.all_stock_data?.product_main_data?.unit_name || "-",
                                serial_number: item.serial_number || "-",
                            });
                        }
                    }
                    
                    formattedReceipt.car_plate = receiptDetail.car_plate || "-";
                    formattedReceipt.user_approve = receiptDetail.user_approve || "-";
                    // Calculate total items
                    formattedReceipt.total_items = formattedReceipt.items.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
                    formattedReceipt.total_price = formattedReceipt.items.reduce((sum, item) => sum + (Number(item.total_price) || 0), 0);

                    sum_total_price += formattedReceipt.total_price
                    processedData.push(formattedReceipt);
                }
            }

            console.log('processedData :',processedData)
            
            this.setState({ sum_total_price: sum_total_price });
            this.setState({ data: processedData });
        } else {
            // Handle API error
            alert("error", "แจ้งเตือน", "เกิดข้อผิดพลาดในการดึงข้อมูล");
            this.setState({ data: [] });
        }
        
        this.setState({ loading: false });
    }

    GetAllStockList = async () => {
        this.setState({ loading: true });
        
        // Call API
        let result = await GET(tokens, "v1/TH/goods-issuance-manage/list/");
        
        if (result && result.status) {
            console.log("Stock data:", result.data);
            
            // Process the data to match our display format
            const processedData = [];
            
            // Check if data is an array (list of receipts) or single object (detailed receipt)
            const receiptsArray = Array.isArray(result.data) ? result.data : [result.data];
            let sum_total_price = 0;
            // For each receipt, get its full details
            for (const receipt of receiptsArray) {
                
                const detailBody = {
                    page: 0,
                    data_search: "",
                    goods_issuance_main_id: receipt.goods_issuance_main_id
                };
                
                const detailResult = await GET(
                    tokens, 
                    "v1/TH/goods-issuance-manage/list/", 
                    detailBody
                );
                
                if (detailResult && detailResult.status) {
                    const receiptDetail = detailResult.data;
                    console.log('receiptDetail.goods_issuance_by',receiptDetail.goods_issuance_by)
                    
                    // Format each receipt into our display format
                    const formattedReceipt = {
                        receipt_id: receiptDetail.goods_issuance_code || "",
                        receipt_date: receiptDetail.goods_issuance_date || "",
                        receipt_type: receiptDetail.deposite_type === "buy" ? "เบิกเพื่อขาย" : "เบิกเพื่อซ่อม",
                        reference_number: receiptDetail.ref_repaire_code || "",
                        company_name: receiptDetail.relation_company ? receiptDetail.relation_company.company_name : 
                                     (receiptDetail.goods_issuance_by_user ? receiptDetail.goods_issuance_by_user.full_name : ""),
                        goods_issuance_by: receiptDetail.goods_issuance_by?.name || "-",
                        items: [],
                    };
                    
                    // Add items from goods_issuance_list
                    if (receiptDetail.goods_issuance_list && receiptDetail.goods_issuance_list.length > 0) {
                        for (const item of receiptDetail.goods_issuance_list) {
                            formattedReceipt.items.push({
                                product_code: item.all_stock_data?.product_main_data?.product_code || "-",
                                product_name: item.all_stock_data?.product_main_data?.product_name || "-",
                                product_type: item.all_stock_data?.warehouse_name || "-",
                                quantity: item.quantity || 0,
                                total_price: item.total_price || 0,
                                price_per_piece: item.price_per_piece || 0,
                                unit: item.all_stock_data?.product_main_data?.unit_name || "-",
                                serial_number: item.serial_number || "-",
                            });
                        }
                    }
                    
                    formattedReceipt.car_plate = receiptDetail.car_plate || "-";
                    formattedReceipt.user_approve = receiptDetail.user_approve || "-";
                    // Calculate total items
                    formattedReceipt.total_items = formattedReceipt.items.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
                    formattedReceipt.total_price = formattedReceipt.items.reduce((sum, item) => sum + (Number(item.total_price) || 0), 0);

                    sum_total_price += formattedReceipt.total_price
                    processedData.push(formattedReceipt);
                }
            }

            console.log('processedData :',processedData)
            
            this.setState({ sum_total_price: sum_total_price });
            this.setState({ dataAll: processedData });
        } else {
            // Handle API error
            alert("error", "แจ้งเตือน", "เกิดข้อผิดพลาดในการดึงข้อมูล");
            this.setState({ dataAll: [] });
        }
        
        this.setState({ loading: false });
    }

    handleSearch = () => {
        this.GetStockList();
    }

    handleCategoryChange = (selected) => {
        this.setState({ selected_category: selected });
    }

    handleStartDateChange = (date) => {
        this.setState({ startDate: date });
    }

    handleEndDateChange = (date) => {
        this.setState({ endDate: date });
    }

    handleSearchTextChange = (e) => {
        this.setState({ searchText: e.target.value });
    }

    exportToExcel = async () => {
        this.setState({ exportLoading: true });
        
        try {
            const { data } = this.state;
            const workbook = XLSXUtils.book_new();
            
            // Add summary worksheet with all items
            const summaryData = [
                ['รายงานสรุปการเบิกสินค้า'],
                [], // Empty row for spacing
                ['เลขที่ใบเบิก', 'วันที่เบิก', 'ประเภทการเบิก', 'ทะเบียนรถ', 'ผู้เบิก', 'เลขที่ใบซ่อม', 'รหัสสินค้า', 'ชื่อสินค้า', 'คลัง/ประเภท', 'จำนวน', 'ราคาขาย/หน่วย', 'ราคารวม', 'หน่วยนับ']
            ];
            
            // Add all items to the summary sheet
            data.forEach(receipt => {
                receipt.items.forEach(item => {
                    summaryData.push([
                        receipt.receipt_id || '-',
                        format_date(receipt.receipt_date, "dd/mm/yyyy", "en")|| '-',
                        receipt.receipt_type || '-',
                        receipt.car_plate || '-',
                        receipt.goods_issuance_by || '-',
                        receipt.reference_number || '-',
                        item.product_code || '-',
                        item.product_name || '-',
                        item.product_type || '-',
                        item.quantity || 0,
                        (new Intl.NumberFormat().format(item.price_per_piece)) || 0,
                        (new Intl.NumberFormat().format(item.total_price)) || 0,
                        item.unit || '-'
                    ]);
                });
            });
            
            const summaryWs = XLSXUtils.aoa_to_sheet(summaryData);
            
            // Set column widths for summary sheet
            const summaryColWidths = [
                { wch: 15 }, // เลขที่ใบเบิก
                { wch: 12 }, // วันที่เบิก
                { wch: 15 }, // ประเภทการเบิก
                { wch: 20 }, // ผู้เบิก
                { wch: 10 }, // เลขที่ใบซ่อม
                { wch: 10 }, // รหัสสินค้า
                { wch: 25 }, // ชื่อสินค้า
                { wch: 15 }, // คลัง/ประเภท
                { wch: 10 }, // จำนวน
                { wch: 15 }, // 
                { wch: 15 }, // 
                { wch: 10 }  // หน่วยนับ
            ];
            
            summaryWs['!cols'] = summaryColWidths;
            
            // Apply some formatting to the header
            summaryWs['A1'] = { t: 's', v: 'รายงานสรุปการเบิกสินค้า', s: { font: { bold: true, sz: 14 } } };
            
            // Add the summary worksheet to the workbook
            XLSXUtils.book_append_sheet(workbook, summaryWs, 'สรุปรายการเบิกสินค้า');
            
            // Generate Excel file
            const excelBuffer = XLSXWrite(workbook, { bookType: 'xlsx', type: 'array' });
            
            // Create Blob and download
            const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
            
            // Generate file name with current date
            const dateStr = new Date().toISOString().slice(0, 10);
            const fileName = `รายงานเบิกสินค้า_${dateStr}.xlsx`;
            
            saveAs(blob, fileName);
            
            alert("success", "แจ้งเตือน", "ดาวน์โหลดรายงาน Excel สำเร็จ");
        } catch (error) {
            console.error("Export to Excel error:", error);
            alert("error", "แจ้งเตือน", "เกิดข้อผิดพลาดในการดาวน์โหลดรายงาน Excel");
        } finally {
            this.setState({ exportLoading: false });
        }
    }

    exportAllToExcel = async () => {
        this.setState({ exportLoading: true });
        
        try {
            const { dataAll } = this.state;
            const workbook = XLSXUtils.book_new();
            
            // Add summary worksheet with all items
            const summaryData = [
                ['รายงานสรุปการเบิกสินค้า'],
                [], // Empty row for spacing
                ['เลขที่ใบเบิก', 'วันที่เบิก', 'ประเภทการเบิก', 'ทะเบียนรถ', 'ผู้เบิก', 'เลขที่ใบซ่อม', 'รหัสสินค้า', 'ชื่อสินค้า', 'คลัง/ประเภท', 'จำนวน', 'ราคาขาย/หน่วย', 'ราคารวม', 'หน่วยนับ']
            ];
            
            // Add all items to the summary sheet
            dataAll.forEach(receipt => {
                receipt.items.forEach(item => {
                    summaryData.push([
                        receipt.receipt_id || '-',
                        format_date(receipt.receipt_date, "dd/mm/yyyy", "en")|| '-',
                        receipt.receipt_type || '-',
                        receipt.car_plate || '-',
                        receipt.goods_issuance_by || '-',
                        receipt.reference_number || '-',
                        item.product_code || '-',
                        item.product_name || '-',
                        item.product_type || '-',
                        item.quantity || 0,
                        (new Intl.NumberFormat().format(item.price_per_piece)) || 0,
                        (new Intl.NumberFormat().format(item.total_price)) || 0,
                        item.unit || '-'
                    ]);
                });
            });
            
            const summaryWs = XLSXUtils.aoa_to_sheet(summaryData);
            
            // Set column widths for summary sheet
            const summaryColWidths = [
                { wch: 15 }, // เลขที่ใบเบิก
                { wch: 12 }, // วันที่เบิก
                { wch: 15 }, // ประเภทการเบิก
                { wch: 20 }, // ผู้เบิก
                { wch: 10 }, // เลขที่ใบซ่อม
                { wch: 10 }, // รหัสสินค้า
                { wch: 25 }, // ชื่อสินค้า
                { wch: 15 }, // คลัง/ประเภท
                { wch: 10 }, // จำนวน
                { wch: 15 }, // 
                { wch: 15 }, // 
                { wch: 10 }  // หน่วยนับ
            ];
            
            summaryWs['!cols'] = summaryColWidths;
            
            // Apply some formatting to the header
            summaryWs['A1'] = { t: 's', v: 'รายงานสรุปการเบิกสินค้า', s: { font: { bold: true, sz: 14 } } };
            
            // Add the summary worksheet to the workbook
            XLSXUtils.book_append_sheet(workbook, summaryWs, 'สรุปรายการเบิกสินค้า');
            
            // Generate Excel file
            const excelBuffer = XLSXWrite(workbook, { bookType: 'xlsx', type: 'array' });
            
            // Create Blob and download
            const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
            
            // Generate file name with current date
            const dateStr = new Date().toISOString().slice(0, 10);
            const fileName = `รายงานเบิกสินค้า_${dateStr}.xlsx`;
            
            saveAs(blob, fileName);
            
            alert("success", "แจ้งเตือน", "ดาวน์โหลดรายงาน Excel สำเร็จ");
        } catch (error) {
            console.error("Export to Excel error:", error);
            alert("error", "แจ้งเตือน", "เกิดข้อผิดพลาดในการดาวน์โหลดรายงาน Excel");
        } finally {
            this.setState({ exportLoading: false });
        }
    }

    exportToPDF = async () => {
        this.setState({ exportLoading: true });
        
        try {
            const { data } = this.state;
            let tableContent = [];
            
            // Process each receipt
            for (const receipt of data) {
                // Add receipt header
                tableContent.push([
                    { 
                        text: "เลขที่เอกสาร: " + (receipt.receipt_id || "-"), 
                        alignment: "center", 
                        fillColor: "#0F4C81", 
                        color: "#ffffff",
                        colSpan: 2
                    },
                    { 
                        text: "วันที่เอกสาร: " + (format_date(receipt.receipt_date, "dd/mm/yyyy", "en") || "-"), 
                        alignment: "center", 
                        fillColor: "#0F4C81", 
                        color: "#ffffff" 
                    },
                    { 
                        text: "ประเภทการเบิก: " + (receipt.receipt_type || "-"), 
                        alignment: "center", 
                        fillColor: "#0F4C81", 
                        color: "#ffffff"
                    },
                    { 
                        text: "เลขที่ใบซ่อม: " + (receipt.reference_number || "-"), 
                        alignment: "center", 
                        fillColor: "#0F4C81", 
                        color: "#ffffff",
                        colSpan: 2
                    },
                    { text: "", fillColor: "#0F4C81" },
                    { text: "", fillColor: "#0F4C81" }
                ]);
                
                // Add second header row with company name
                tableContent.push([
                    { 
                        text: "ผู้เบิก: " + (receipt.goods_issuance_by || "-"), 
                        alignment: "center", 
                        fillColor: "#0F4C81", 
                        color: "#ffffff",
                        colSpan: 6
                    },
                    {}, {}, {}, {}, {}
                ]);
                
                // Add column headers
                tableContent.push([
                    { text: "รหัสสินค้า", alignment: "center", fillColor: "#e8eaed" },
                    { text: "ชื่อสินค้า", alignment: "center", fillColor: "#e8eaed" },
                    { text: "คลัง/ประเภท", alignment: "center", fillColor: "#e8eaed" },
                    { text: "จำนวน", alignment: "center", fillColor: "#e8eaed" },
                    { text: "ราคาขาย/หน่วย", alignment: "center", fillColor: "#e8eaed" },
                    { text: "ราคารวม", alignment: "center", fillColor: "#e8eaed" }
                ]);
                
                // Add items
                for (const item of receipt.items) {
                    tableContent.push([
                        { text: item.product_code || "-", alignment: "center" },
                        { text: item.product_name || "-", alignment: "left" },
                        { text: item.product_type || "-", alignment: "center" },
                        { text: (item.quantity || "0") + " " + (item.unit || "-"), alignment: "right" },
                        { text: (new Intl.NumberFormat().format(item.price_per_piece) || "0"), alignment: "right" },
                        { text: (new Intl.NumberFormat().format(item.total_price) || "0"), alignment: "right" }
                    ]);
                }
                
                // Add total row - only need one
                tableContent.push([
                    { text: "", alignment: "center" },
                    { text: "", alignment: "center" },
                    { text: "รวม:", alignment: "right", bold: true },
                    { text: (receipt.total_items || "0") + " รายการ", alignment: "right", bold: true },
                    { text: "ราคารวม:", alignment: "right", bold: true },
                    { text: (new Intl.NumberFormat().format(receipt.total_price) || "0"), alignment: "right", bold: true }
                ]);
                
                // Add empty row for spacing between receipts if not the last receipt
                if (data.indexOf(receipt) < data.length - 1) {
                    tableContent.push([
                        { text: "", border: [false, false, false, false], margin: [0, 10, 0, 10] },
                        { text: "", border: [false, false, false, false], margin: [0, 10, 0, 10] },
                        { text: "", border: [false, false, false, false], margin: [0, 10, 0, 10] },
                        { text: "", border: [false, false, false, false], margin: [0, 10, 0, 10] },
                        { text: "", border: [false, false, false, false], margin: [0, 10, 0, 10] },
                        { text: "", border: [false, false, false, false], margin: [0, 10, 0, 10] }
                    ]);
                }
            }
            
            // Add grand total at the end
            if (data.length > 0) {
                tableContent.push([
                    { text: "", alignment: "center" },
                    { text: "", alignment: "center" },
                    { text: "", alignment: "center" },
                    { text: "", alignment: "center" },
                    { text: "ราคารวมสุทธิ:", alignment: "right", bold: true, fillColor: "#e8eaed" },
                    { text: new Intl.NumberFormat().format(this.state.sum_total_price) || "0", alignment: "right", bold: true, fillColor: "#e8eaed" }
                ]);
            }
            
            // Generate date for filename
            const dateStr = new Date().toISOString().slice(0, 10);
            const fileName = `รายงานเบิกสินค้า_${dateStr}.pdf`;
            
            // Set up Thai font
            pdfMake.vfs = pdfFonts.pdfMake.vfs;
            
            // Create document definition
            const docDefinition = {
                content: [
                    { text: "รายงานเบิกสินค้า", alignment: "center", fontSize: 20, bold: true, margin: [0, 0, 0, 10] },
                    {
                        table: {
                            headerRows: 0,
                            widths: ['10%', '45%', '15%', '10%', '10%', '10%'],
                            body: tableContent
                        }
                    }
                ],
                defaultStyle: { 
                    font: "THSarabunNew", 
                    fontSize: 12
                },
                pageSize: "A4",
                pageMargins: [15, 15, 15, 15],
                pageOrientation: 'landscape',
            };
            
            // Generate and download PDF
            pdfMake.createPdf(docDefinition).download(fileName);
            
            alert("success", "แจ้งเตือน", "ดาวน์โหลดรายงาน PDF สำเร็จ");
        } catch (error) {
            console.error("Export to PDF error:", error);
            alert("error", "แจ้งเตือน", "เกิดข้อผิดพลาดในการดาวน์โหลดรายงาน PDF");
        } finally {
            this.setState({ exportLoading: false });
        }
    }

    render() {
        const { data } = this.state;
        
        return (
            <div className="w-100 min-vh-100 fade-in">
                {this.state.loading && (<div className="spinner-container"> <div className="loading-spinner"></div> </div>)}
                <Navbar page1="หน้าหลัก" page2="รายงานเบิกสินค้า" />
                
                {/* BODY */}
                <div className="body bg-light min-vh-100">
                    <div className="p-3">
                        {/* หัวข้อ และ ปุ่มเพิ่ม */}
                        <div className="d-flex mx-0 align-items-center justify-content-between test mb-2 flex-wrap">
                            <h3 className="mb-2"><b>รายงานเบิกสินค้า</b></h3>
                            <div>
                                {/* <button 
                                    className="btn btn-success mx-1" 
                                    onClick={this.exportAllToExcel}
                                    disabled={this.state.exportLoading}>
                                    <span className="icon me-2">{"\uf1c3"}</span>ALL Data Excel
                                </button> */}
                                <button 
                                    className="btn btn-success mx-1" 
                                    onClick={this.exportToExcel}
                                    disabled={this.state.exportLoading}>
                                    <span className="icon me-2">{"\uf1c3"}</span>Excel
                                </button>
                                <button 
                                    className="btn btn-danger mx-1" 
                                    onClick={this.exportToPDF}
                                    disabled={this.state.exportLoading}>
                                    <span className="icon me-2">{"\uf1c1"}</span>PDF
                                </button>
                            </div>
                        </div>

                        {/* Search Filters */}
                        <div className="w-100 card border-0 p-3 rounded-lg mb-3">
                            <div className="row">
                                <div className="col-12 col-md-3 mb-2">
                                    <label className="mb-2">ค้นหา:</label>
                                    <div className="input-group">
                                        <input
                                            className="form-control"
                                            type="text"
                                            placeholder="ค้นหาเลขที่สินค้า หรือ ชื่อสินค้า"
                                            onChange={this.handleSearchTextChange}
                                            value={this.state.searchText}
                                        />
                                        <span className="input-group-text bg-white">
                                            <span className="icon text-muted">{"\uf002"}</span>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-12 col-md-3 mb-2">
                                    <label className="mb-2">คลังสินค้า:</label>
                                    <Select
                                        className="form-control select-search"
                                        styles={select_style}
                                        options={this.state.data_warehouse}
                                        onChange={(selected) => {
                                            this.setState({ selected_warehouse: selected });
                                        }}
                                        value={this.state.selected_warehouse}
                                        placeholder="เลือกคลังสินค้า"
                                        isClearable
                                    />
                                </div>
                                <div className="col-12 col-md-2 mb-2">
                                    <label className="mb-2">วันที่เริ่มต้น:</label>
                                    <CustomDatePicker
                                        selected={this.state.startDate}
                                        onChange={this.handleStartDateChange}
                                        placeholderText="เลือกวันที่เริ่มต้น"
                                        maxDate={this.state.endDate}
                                    />
                                </div>
                                <div className="col-12 col-md-2 mb-2">
                                    <label className="mb-2">วันที่สิ้นสุด:</label>
                                    <CustomDatePicker
                                        selected={this.state.endDate}
                                        onChange={this.handleEndDateChange}
                                        placeholderText="เลือกวันที่สิ้นสุด"
                                        minDate={this.state.startDate}
                                    />
                                </div>
                                <div className="col-12 col-md-2 mb-2 d-flex align-items-end">
                                    <button 
                                        className="btn btn-primary me-2" 
                                        onClick={this.handleSearch}>
                                        <span className="icon me-2">{"\uf002"}</span>ค้นหา
                                    </button>
                                    <button 
                                        className="btn btn-outline-secondary" 
                                        onClick={() => {
                                            this.setState({
                                                searchText: "",
                                                selected_warehouse: null,
                                                selected_product: null,
                                                startDate: null,
                                                endDate: null
                                            }, () => {
                                                this.GetStockList();
                                            });
                                        }}>
                                        <span className="icon me-2">{"\uf021"}</span>รีเซ็ต
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Stock Report Display */}
                        <div className="card border rounded-lg p-3 mb-3 stock-report-container">
                            {data.length > 0 ? (
                                data.map((receipt, index) => (
                                    <div key={index} className="mb-4">
                                        {/* Receipt Header */}
                                        <div className="bg-primary text-white p-2 d-flex justify-content-between">
                                            <div>
                                                <span className="me-3">เลขที่เอกสาร: {receipt.receipt_id}</span>
                                                <span className="me-3">วันที่เอกสาร: {format_date(receipt.receipt_date, "dd/mm/yyyy", "en")}</span>
                                            </div>
                                            <div>
                                                <span className="me-3">ประเภทการเบิก: {receipt.receipt_type}</span>
                                                <span>เลขทะเบียน: {receipt.car_plate}</span>
                                            </div>
                                            <div>
                                                <span>ผู้เบิก: {receipt.goods_issuance_by}</span>
                                            </div>
                                        </div>

                                        {/* Item Table */}
                                        <div className="table-responsive">
                                            <table className="table table-bordered table-hover mb-0">
                                                <thead className="bg-light">
                                                    <tr>
                                                        <th className="text-center" style={{width: "10%"}}>รหัสสินค้า</th>
                                                        <th className="text-left" style={{width: "35%"}}>ชื่อสินค้า</th>
                                                        <th className="text-center" style={{width: "15%"}}>ประเภท</th>
                                                        <th className="text-center" style={{width: "10%"}}>จำนวน</th>
                                                        <th className="text-center" style={{width: "10%"}}>หน่วยนับ</th>
                                                        <th className="text-center" style={{width: "10%"}}>ราคาขาย/หน่วย</th>
                                                        <th className="text-center" style={{width: "10%"}}>ราคารวม</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {receipt.items.map((item, itemIndex) => (
                                                        <tr key={itemIndex}>
                                                            <td className="text-center">{item.product_code}</td>
                                                            <td>{item.product_name}</td>
                                                            <td className="text-center">{item.product_type}</td>
                                                            <td className="text-center">{item.quantity}</td>
                                                            <td className="text-center">{item.unit}</td>
                                                            <td className="text-center">{new Intl.NumberFormat().format(item.price_per_piece)}</td>
                                                            <td className="text-center">{new Intl.NumberFormat().format(item.total_price)}</td>
                                                        </tr>
                                                    ))}
                                                    <tr className="bg-light">
                                                        <td colSpan="3" className="text-end"><strong>รวม</strong></td>
                                                        <td className="text-center"><strong>{receipt.total_items}</strong></td>
                                                        <td colSpan="2" className="text-end"><strong>ราคารวม</strong></td>
                                                        <td className="text-center"><strong>{new Intl.NumberFormat().format(receipt.total_price)}</strong></td> 
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="text-center py-5">
                                    <h5>ไม่พบข้อมูลการเบิกสินค้า</h5>
                                    <p>กรุณาปรับเงื่อนไขการค้นหาใหม่</p>
                                </div>
                            )}

                            <table className="table table-bordered table-hover mb-0">
                                <tbody>
                                    <tr className="bg-light">
                                        <td colSpan="2" className="text-end" style={{width: "80%"}} ><strong>ราคารวมสุทธิ</strong></td>
                                        <td className="text-center"><strong>{new Intl.NumberFormat().format(this.state.sum_total_price)}</strong></td> 
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}